import { HttpStatusCode } from "axios";
import networkService from "./NetworkService";
import IBlogTag from "../models/blog/IBlogTag";

class TagService {
    async getTags(): Promise<IBlogTag[]> {
        const result = await networkService.get<IBlogTag[]>("/blog/tags");

        if (!result.isSuccessful) {
            throw result.data;
        }

        return result.status !== HttpStatusCode.NoContent
            ? result.data as IBlogTag[]
            : [];
    }

    async createTag(tag: IBlogTag): Promise<string> {
        const result = await networkService.put<IBlogTag, string>("/blog/tag", tag);

        if (result.isSuccessful) {
            return result.data as string;
        }

        throw result.data;
    }

    async updateTag(tag: IBlogTag): Promise<void> {
        const result = await networkService.patch<IBlogTag, void>("/blog/tag", tag);

        if (!result.isSuccessful) {
            throw result.data;
        }
    }

     async deleteTag(id: string): Promise<boolean> {
        const result = await networkService.delete<void>(`/blog/tag/${id}`);
        return result.isSuccessful;
    }
}

const tagService = new TagService();
export default tagService;
